import axios from "axios";
import { API_BASE_URL } from "../../config";

const settingsAPI = {
  // Get bank representatives
  getRepresentatives: async (id) => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/banking-partners/representatives/${id}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching banking partner representatives:", error);
      throw error.response?.data || error.message;
    }
  },

  // Add new representative
  addRepresentative: async (representativeData, id) => {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/banking-partner/addOrUpdateRepresentatives/${id}`,
        representativeData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        }
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Update representative
  updateRepresentative: async (id, representativeData) => {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/banking-partner/addOrUpdateRepresentatives/${id}`,
        representativeData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        }
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Delete representative
  deleteRepresentative: async (id, email) => {
    try {
      const response = await axios.delete(
        `${API_BASE_URL}/banking-partners/${id}/representatives`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
          data: { email },
        }
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Get bank information
  getBankInfo: async (id) => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/banking-partners/${id}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        }
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Update bank information
  updateBankInfo: async (id, bankInfo) => {
    try {
      const response = await axios.put(
        `${API_BASE_URL}/banking-partners/${id}`,
        bankInfo,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        }
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Get bank documents
  getBankDocuments: async (id) => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/banking-partners/${id}/compliance-documents`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        }
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },
};

export default settingsAPI;
